<template>
	<div class="row">
		<div class="col-lg-12">
			<div class="white-box">
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<h3 class="box-title pull-left">Mi actividad</h3>
					</div>
				</div>
				<div class="row">
					<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
						<!--
						<p class="text-muted m-b-40">Use default tab with class <code>nav-tabs</code></p>
						-->
						<!-- Nav tabs -->
						<ul class="nav nav-tabs" role="tablist">
							<li role="presentation" class="active">
								<a href="#budgets" role="tab" data-toggle="tab" aria-expanded="true">
									<span>
										<i class="fa fa-clipboard fa-fw"></i>
										<span class=""><b>Presupuestos</b></span>
									</span>
								</a>
							</li>
						</ul>
						<!-- Tab panes -->
						<div class="tab-content">
							<div role="tabpanel" class="tab-pane active" id="budgets">
								<div class="col-md-12">
									<budgets :user="user" :isAuth="isAuth"></budgets>
								</div>
								<div class="clearfix"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Budgets from './../views/Budgets'
	export default {
		props: ['user', 'isAuth'],
		components: {
			'budgets': Budgets,
		},
		data () {
			return {
				
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/activity/layout/Activity.vue